import LayoutHeader from './LayoutHeader';
import LayoutFilter from './LayoutFilter';

const Layout = {LayoutHeader, LayoutFilter};

export default Layout;
